export default __webpack_public_path__ + "static/ihlogo-b05a0e9c8564bce100a468095890ed78.svg";